export default {
  saveRecipeAs: {
    header: 'Rezept speichern unter',
  },
};
